var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"rounded-circle",staticStyle:{"height":"60px","width":"60px"},attrs:{"src":_vm.isExistAvatar ? _vm.user.avatar : _vm.user.default_avatar},on:{"error":function($event){_vm.isExistAvatar = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }